export default __webpack_public_path__ + "static/media/ll.dcebe76f.png";